module.exports = __webpack_public_path__ + "img/two-checkout-logo.d32bf67d.svg";